var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("../../assets/images/common/zengzhi.png"),"alt":""}})])])
}]

export { render, staticRenderFns }